// NPM
import React from "react";
import _ from "lodash";

// State
import { useSelector } from "react-redux";

// Services
import renderService from "services/renderService";

function Credits() {
  // State
  const campaignConfig = useSelector((state) => state.campaignConfig.value);

  if (
    !campaignConfig.sections?.Credits ||
    !renderService.canRender([campaignConfig])
  ) {
    return null;
  }

  const creditsContent = _.get(
    campaignConfig,
    "sections.Credits.content",
    [],
  ).join(" ");

  return (
    <div id="Credits" className="Credits Signal__section">
      <img src={require("images/vpl-logo.png")} className="Credits__logo" />
      <div
        className="Credits__content"
        dangerouslySetInnerHTML={{ __html: creditsContent }}
      />
    </div>
  );
}

export default Credits;
